import React, { useState, useEffect } from 'react';
import { Layout, Row, Col, Card, Typography } from 'antd';
import DoctorProfile from './components/DoctorProfile';
import ChatInterface from './components/ChatInterface';
import LoadingScreen from './components/LoadingScreen';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';

const { Header, Content } = Layout;
const { Title, Text } = Typography;

function App() {
  const [loading, setLoading] = useState(true);
  const [doctorProfile, setDoctorProfile] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        // 模拟初始化过程
        await new Promise(resolve => setTimeout(resolve, 1500));
        
        setDoctorProfile({
          name: 'Dr. Duan',
          title: '口腔医学博士',
          specialty: '临床正畸专家',
          experience: '丰富的正畸临床实践经验与教学经验',
          avatar: '/images/Dr. Duan.png'
        });
        
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    initializeApp();
  }, []);

  const resetError = () => {
    setError(null);
    setLoading(true);
    // 重新初始化
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  if (loading) {
    return <LoadingScreen message="正在连接Dr. Duan..." />;
  }

  if (error) {
    return <ErrorBoundary error={error} resetError={resetError} />;
  }

  return (
    <ErrorBoundary error={error} resetError={resetError}>
      <Layout className="app-layout">
        <Header className="app-header">
          <div className="header-content">
            <div className="logo">
              <span className="logo-icon">🦷</span>
              <Title level={3} style={{ color: 'white', margin: 0 }}>
                Dr. Duan 数字分身
              </Title>
            </div>
            <Text style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
              专业 · 精准 · 可信赖的口腔正畸专家
            </Text>
          </div>
        </Header>
        
        <Content className="app-content">
          <div className="content-wrapper">
            <Row gutter={[24, 24]} style={{ height: '100%' }}>
              <Col xs={24} lg={8}>
                <Card className="doctor-card" bodyStyle={{ padding: 0 }}>
                  <DoctorProfile profile={doctorProfile} />
                </Card>
              </Col>
              
              <Col xs={24} lg={16}>
                <Card className="chat-card" bodyStyle={{ padding: 0, height: '100%' }}>
                  <ChatInterface />
                </Card>
              </Col>
            </Row>
          </div>
        </Content>
      </Layout>
    </ErrorBoundary>
  );
}

export default App;
